import { render, staticRenderFns } from "./BusinessCardGenerator.vue?vue&type=template&id=9d642928&scoped=true&"
import script from "./BusinessCardGenerator.vue?vue&type=script&lang=js&"
export * from "./BusinessCardGenerator.vue?vue&type=script&lang=js&"
import style0 from "./BusinessCardGenerator.vue?vue&type=style&index=0&id=9d642928&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d642928",
  null
  
)

export default component.exports